import React, { useEffect, useState } from "react";
import { accessDocument } from "../../../prismicApi";
import styles from "assets/jss/material-kit-react/views/landingPageSections/aboutStyle.js";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { isMobile } from "react-device-detect";
import useWindowSize from "useWindowSize";
import * as Fathom from "fathom-client";

const useStyles = makeStyles(styles);

const AboutText = ({
  english,
  section,
  imageSource,
  imageCredit,
  imageAlt,
}) => {
  const classes = useStyles();
  const [doc, setDoc] = useState(null);
  const { width } = useWindowSize();
  const [expandSection, setExpandSection] = useState(false);

  const handleToggle = async (bool) => {
    if (bool) {
      Fathom.trackGoal("GHMQAK4Q", 0);
    }
    setExpandSection(bool);
  };
  useEffect(() => {
    accessDocument(section).then((result) => setDoc(result));
  }, [section]);

  return (
    <div className={classes.aboutContainer} id={section}>
      <figure className={classes.aboutImgWrapper}>
        <img src={imageSource} alt={imageAlt} className={classes.aboutImage} />
        <figcaption className={classes.aboutImgCaption}>
          {english ? "Photo: " : "Foto: "}
          {imageCredit}
        </figcaption>
      </figure>

      <h1 className={classes.aboutTitle}>
        {english
          ? doc && doc.length !== 0 && doc[0].english_title[0].text
          : doc && doc.length !== 0 && doc[0].title[0].text}
      </h1>
      <div
        className={isMobile ? classes.mobileContainer : classes.mobileContainer}
      >
        <div
          className={
            isMobile
              ? classes.mobileDescription
              : width > 1000
              ? classes.description
              : classes.mobileDescription
          }
        >
          {english
            ? doc &&
              doc.length !== 0 &&
              doc[0].english_text.map((item, index) => {
                if (expandSection) {
                  return (
                    <p
                      key={index}
                      className={isMobile ? classes.mobileItem : classes.item}
                    >
                      {item.text}
                      {index === doc[0].english_text.length - 1 && (
                        <button
                          className={classes.readMore}
                          onClick={() => handleToggle(!expandSection)}
                        >
                          {expandSection
                            ? english
                              ? "\nMinimize"
                              : "\nMinimer"
                            : english
                            ? "\nRead more"
                            : "\nLes mer"}
                        </button>
                      )}
                    </p>
                  );
                } else {
                  if (index <= 4) {
                    return (
                      <p
                        key={index}
                        className={isMobile ? classes.mobileItem : classes.item}
                      >
                        {item.text}
                        {index === 4 && doc[0].english_text.length > 1 && (
                          <button
                            className={classes.readMore}
                            onClick={() => handleToggle(!expandSection)}
                          >
                            {expandSection
                              ? english
                                ? "\nMinimize"
                                : "\nMinimer"
                              : english
                              ? "\nRead more"
                              : "\nLes mer"}
                          </button>
                        )}
                      </p>
                    );
                  }
                }
                return <p key={index} />;
              })
            : doc &&
              doc.length !== 0 &&
              doc[0].text.map((item, index) => {
                if (expandSection) {
                  return (
                    <p
                      key={index}
                      className={isMobile ? classes.mobileItem : classes.item}
                    >
                      {item.text}
                      {index === doc[0].text.length - 1 && (
                        <button
                          className={classes.readMore}
                          onClick={() => handleToggle(!expandSection)}
                        >
                          {expandSection
                            ? english
                              ? "\nMinimize"
                              : "\nMinimer"
                            : english
                            ? "\nRead more"
                            : "\nLes mer"}
                        </button>
                      )}
                    </p>
                  );
                } else {
                  if (index <= 4) {
                    return (
                      <p
                        key={index}
                        className={isMobile ? classes.mobileItem : classes.item}
                      >
                        {item.text}
                        {index === 4 && doc[0].text.length > 1 && (
                          <button
                            className={classes.readMore}
                            onClick={() => handleToggle(!expandSection)}
                          >
                            {expandSection
                              ? english
                                ? "\nMinimize"
                                : "\nMinimer"
                              : english
                              ? "\nRead more"
                              : "\nLes mer"}
                          </button>
                        )}
                      </p>
                    );
                  }
                }
                return <p key={index} />;
              })}
        </div>
      </div>
    </div>
  );
};

AboutText.propTypes = {
  english: PropTypes.bool,
  section: PropTypes.string,
};
export default AboutText;
